import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FGrid, FGridMoneyCell } from '../grid';

type Props = {
  rows: any[];
  loading?: boolean;
};

class BudgetConsolidationCostCenterGrid extends React.Component<Props> {
  columns: GridColDef[] = [
    { field: 'costcentercode', headerName: 'Cost Center', width: 140 },
    { field: 'costcentername', headerName: 'Cost Center Name', flex: 1, minWidth: 280 },
    { field: 'activitybudget', headerName: 'Activity', width: 150, renderCell: FGridMoneyCell },
    { field: 'directbudget', headerName: 'Direct', width: 150, renderCell: FGridMoneyCell },
    { field: 'investmentbudget', headerName: 'Investment', width: 150, renderCell: FGridMoneyCell },
    { field: 'totalbudget', headerName: 'Total', width: 160, renderCell: FGridMoneyCell },
  ];

  render() {
    return (
      <FGrid
        title="Consolidation by Cost Center"
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={420}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#e7f6ea' }}
        getRowId={(row: any) => row.costcenterid || row.costcentercode}
        pageSizeOptions={[10, 20, 50]}
        initialState={{
          pagination: { paginationModel: { pageSize: 10 } },
        }}
      />
    );
  }
}

export default BudgetConsolidationCostCenterGrid;
